import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { simpleRequestsLoader } from 'modules/app/utils';

import * as actions from './actions';
import * as types from './actionTypes';
import { DASHBOARD_SOURCE } from './constants';
import requestsConfig from './requestsConfig';
import { getBaseRequestParams } from './selectors';

const CRUD_ACTIONS = [
  types.CREATE_WHITELIST_SUCCESS,
  types.UPDATE_WHITELIST_SUCCESS,
  types.DELETE_WHITELIST_SUCCESS
];

const REFRESH_FILTERS_ACTIONS = [
  SELECT_DEALER,
  types.SET_FILTER,
  types.CLEAR_FILTERS
];

function* fetchWhitelistWithFilters() {
  const params: ReturnType<typeof getBaseRequestParams> = yield select(getBaseRequestParams);
  yield put(actions.fetchWhitelist(params, { source: DASHBOARD_SOURCE }));
}

function* onPageWorker() {
  yield call(fetchWhitelistWithFilters);
  yield takeLatest(CRUD_ACTIONS, fetchWhitelistWithFilters);
  yield takeLatest(REFRESH_FILTERS_ACTIONS, fetchWhitelistWithFilters);
}

export default function* whitelistSaga() {
  yield scopeToPage([PATH.WHITELIST], onPageWorker);
  yield all(simpleRequestsLoader(requestsConfig));
}
